import { jsx as n } from "react/jsx-runtime";
import o from "react";
import r from "../../_virtual/index.es.js";
import a from "../text/Text.es.js";
import { rootStyles as g } from "./TagStatusLight.styles.es.js";
const p = ["pendingFill", "warningFill", "destructiveFill", "highlight1Fill", "highlight2Fill", "successFill", "darkFill", "pendingOutline", "warningOutline", "destructiveOutline", "highlight1Outline", "highlight2Outline", "successOutline", "darkOutline", "neutralFill"], u = ({
  className: t,
  variant: i,
  children: l,
  sx: e,
  ...s
}) => /* @__PURE__ */ n(a, { className: r(g({
  variant: i,
  css: e
}), t), fontSize: "small", fontWeight: "$semiBold", ...s, children: l }), F = o.memo(u);
export {
  F as default,
  p as variants
};
//# sourceMappingURL=TagStatusLight.es.js.map
